import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";
import AdminChat from "@/components/AdminChat";
import { MessagesSquare, X, ExternalLink } from "lucide-react";

export default function AdminChatDock() {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  const [unread, setUnread] = useState(0);
  const isAdmin = user && user.role === "admin";

  useEffect(() => {
    if (!isAdmin) return;
    const poll = () => api.get("/admin/chat/unread").then((r) => setUnread(r.data.unread || 0)).catch(() => {});
    poll();
    const t = setInterval(poll, 6000);
    return () => clearInterval(t);
  }, [isAdmin]);

  if (!isAdmin) return null;

  return (
    <>
      <button onClick={() => setOpen((v) => !v)} data-testid="admin-chat-header-btn"
        className="relative p-2 rounded-full hover:bg-slate-100 transition-colors" title="Chat Konsumen">
        <MessagesSquare className="w-5 h-5 text-[#00133F]" />
        {unread > 0 && (
          <span data-testid="admin-chat-header-unread" className="absolute -top-0.5 -right-0.5 bg-[#F0005A] text-white text-[10px] font-bold w-5 h-5 rounded-full flex items-center justify-center">{unread}</span>
        )}
      </button>
      {open && createPortal(
        <div className="fixed bottom-4 right-4 z-[80] w-[94vw] sm:w-[680px] max-w-[680px] no-print" data-testid="admin-chat-popup">
          <div className="rounded-2xl shadow-2xl border border-slate-200 bg-white overflow-hidden">
            <div className="flex items-center justify-between px-4 py-2.5 bg-[#00133F] text-white">
              <span className="font-heading font-semibold text-sm flex items-center gap-2"><MessagesSquare className="w-4 h-4 text-[#F0005A]" /> Chat Konsumen</span>
              <div className="flex items-center gap-1.5">
                <button onClick={() => window.open("/admin/chat", "_blank")} data-testid="open-full-chat-btn"
                  className="flex items-center gap-1 text-xs bg-white/10 hover:bg-white/20 px-2.5 py-1 rounded-full transition-colors">
                  <ExternalLink className="w-3.5 h-3.5" /> Buka Full Chat
                </button>
                <button onClick={() => setOpen(false)} data-testid="admin-chat-popup-close" className="p-1 hover:bg-white/10 rounded-full"><X className="w-4 h-4" /></button>
              </div>
            </div>
            <AdminChat heightClass="h-[440px]" hideHeader />
          </div>
        </div>, document.body)}
    </>
  );
}
